// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeBuyersCourse_div__7BEjn {
    display: flex;
    margin-top: 7px;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div__7BEjn {
      max-width: 100%;
      margin-top: 40px;
    }
  }
  .HomeBuyersCourse_t__eNSfw {
    display: flex;
    gap: 20px;
  }
  .HomeBuyersCourse_sideBar__swm0k {
    gap: 20px;
    display: flex;
    min-height: 100%;
    justify-content: flex-start;
  }
  .HomeBuyersCourse_div2__1oItL {
    color: #077aff;
    max-width: 600px;
    margin-top: 21px;
    font: 700 32px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div2__1oItL {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div3__qIFzh {
    align-self: stretch;
    margin-top: 71px;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div3__qIFzh {
      max-width: 100%;
      margin-top: 40px;
    }
  }
  .HomeBuyersCourse_div4__UPvcJ {
    gap: 20px;
    display: flex;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div4__UPvcJ {
      flex-direction: column;
      align-items: stretch;
      gap: 0px;
    }
  }
  .HomeBuyersCourse_column__I6wjV {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 47%;
    margin-left: 0px;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_column__I6wjV {
      width: 100%;
    }
  }
  .HomeBuyersCourse_div5__l9KwL {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div5__l9KwL {
      max-width: 100%;
      margin-top: 40px;
    }
  }
  .HomeBuyersCourse_div6__hJBP5 {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    font: 500 36px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div6__hJBP5 {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div7__1eE3k {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 43px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;

    background:none;
    border:none;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div7__1eE3k {
      max-width: 100%;
      margin-top: 40px;
    }
  }
  .HomeBuyersCourse_div8__Pj7vr {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 31px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div8__Pj7vr {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div9__8ZHbH {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 31px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div9__8ZHbH {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div10__qNWag {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 29px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div10__qNWag {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div11__Tkdh4 {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 36px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div11__Tkdh4 {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div12__NBaYv {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 31px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div12__NBaYv {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div13__e3C0f {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 31px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div13__e3C0f {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div14__be9vY {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 37px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div14__be9vY {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_div15__ekM7e {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 30px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div15__ekM7e {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_column2__ZzGrv {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 53%;
    margin-left: 20px;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_column2__ZzGrv {
      width: 100%;
    }
  }
  .HomeBuyersCourse_div16__Hkg8j {
    display: flex;
    margin-top: 25px;
    flex-direction: column;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div16__Hkg8j {
      max-width: 100%;
      margin-top: 40px;
    }
  }
  .HomeBuyersCourse_div17__B3a-\\+ {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    display: flex;
    min-height: 350px;
    width: 100%;
    justify-content: center;
    align-items: start;
    padding: 50px 20px;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div17__B3a-\\+ {
      max-width: 100%;
    }
  }
  .HomeBuyersCourse_img__d9kt1 {
    position: absolute;
    inset: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
  .HomeBuyersCourse_img2__\\+BA9P {
    aspect-ratio: 1.77;
    object-fit: contain;
    object-position: center;
    width: 152px;
    overflow: hidden;
    max-width: 100%;
    margin: 71px 0 64px 129px;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_img2__\\+BA9P {
      margin: 40px 0 40px 10px;
    }
  }
  .HomeBuyersCourse_div18__omvaj {
    justify-content: center;
    color: #fff;
    text-align: center;
    border-radius: 16.842px;
    box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
    background-color: #0a96e5;
    align-self: start;
    width: 195px;
    max-width: 100%;
    /* margin: 34px 0 0 136px; */
    padding: 10px 0;
    font: 800 15px Lato, sans-serif;
  }
  @media (max-width: 991px) {
    .HomeBuyersCourse_div18__omvaj {
      margin-left: 10px;
    }
  }

  .HomeBuyersCourse_modDiv__0Q76G {
    color: #000;
    text-align: start;
    font-feature-settings: "clig" off, "liga" off;
    margin-top: 31px;
    margin-left: 20px;
    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/HomeBuyersCourse.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;EACA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;EACjC;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;EACA;IACE,SAAS;IACT,aAAa;EACf;EACA;IACE;MACE,sBAAsB;MACtB,oBAAoB;MACpB,QAAQ;IACV;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE;MACE,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;;IAEZ,eAAe;IACf,WAAW;EACb;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB;gBACY;EACd;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE;MACE,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE;MACE,wBAAwB;IAC1B;EACF;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,wEAAwE;IACxE,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,+BAA+B;EACjC;EACA;IACE;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,6CAA6C;IAC7C,gBAAgB;IAChB,iBAAiB;IACjB;gBACY;EACd","sourcesContent":[".div {\n    display: flex;\n    margin-top: 7px;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 20px;\n  }\n  @media (max-width: 991px) {\n    .div {\n      max-width: 100%;\n      margin-top: 40px;\n    }\n  }\n  .t {\n    display: flex;\n    gap: 20px;\n  }\n  .sideBar {\n    gap: 20px;\n    display: flex;\n    min-height: 100%;\n    justify-content: flex-start;\n  }\n  .div2 {\n    color: #077aff;\n    max-width: 600px;\n    margin-top: 21px;\n    font: 700 32px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div2 {\n      max-width: 100%;\n    }\n  }\n  .div3 {\n    align-self: stretch;\n    margin-top: 71px;\n  }\n  @media (max-width: 991px) {\n    .div3 {\n      max-width: 100%;\n      margin-top: 40px;\n    }\n  }\n  .div4 {\n    gap: 20px;\n    display: flex;\n  }\n  @media (max-width: 991px) {\n    .div4 {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 0px;\n    }\n  }\n  .column {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 47%;\n    margin-left: 0px;\n  }\n  @media (max-width: 991px) {\n    .column {\n      width: 100%;\n    }\n  }\n  .div5 {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n  }\n  @media (max-width: 991px) {\n    .div5 {\n      max-width: 100%;\n      margin-top: 40px;\n    }\n  }\n  .div6 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    font: 500 36px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div6 {\n      max-width: 100%;\n    }\n  }\n  .div7 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 43px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n\n    background:none;\n    border:none;\n  }\n  @media (max-width: 991px) {\n    .div7 {\n      max-width: 100%;\n      margin-top: 40px;\n    }\n  }\n  .div8 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 31px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div8 {\n      max-width: 100%;\n    }\n  }\n  .div9 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 31px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div9 {\n      max-width: 100%;\n    }\n  }\n  .div10 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 29px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div10 {\n      max-width: 100%;\n    }\n  }\n  .div11 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 36px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div11 {\n      max-width: 100%;\n    }\n  }\n  .div12 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 31px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div12 {\n      max-width: 100%;\n    }\n  }\n  .div13 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 31px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div13 {\n      max-width: 100%;\n    }\n  }\n  .div14 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 37px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div14 {\n      max-width: 100%;\n    }\n  }\n  .div15 {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 30px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div15 {\n      max-width: 100%;\n    }\n  }\n  .column2 {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 53%;\n    margin-left: 20px;\n  }\n  @media (max-width: 991px) {\n    .column2 {\n      width: 100%;\n    }\n  }\n  .div16 {\n    display: flex;\n    margin-top: 25px;\n    flex-direction: column;\n  }\n  @media (max-width: 991px) {\n    .div16 {\n      max-width: 100%;\n      margin-top: 40px;\n    }\n  }\n  .div17 {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    position: relative;\n    display: flex;\n    min-height: 350px;\n    width: 100%;\n    justify-content: center;\n    align-items: start;\n    padding: 50px 20px;\n  }\n  @media (max-width: 991px) {\n    .div17 {\n      max-width: 100%;\n    }\n  }\n  .img {\n    position: absolute;\n    inset: 0;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n  .img2 {\n    aspect-ratio: 1.77;\n    object-fit: contain;\n    object-position: center;\n    width: 152px;\n    overflow: hidden;\n    max-width: 100%;\n    margin: 71px 0 64px 129px;\n  }\n  @media (max-width: 991px) {\n    .img2 {\n      margin: 40px 0 40px 10px;\n    }\n  }\n  .div18 {\n    justify-content: center;\n    color: #fff;\n    text-align: center;\n    border-radius: 16.842px;\n    box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n    background-color: #0a96e5;\n    align-self: start;\n    width: 195px;\n    max-width: 100%;\n    /* margin: 34px 0 0 136px; */\n    padding: 10px 0;\n    font: 800 15px Lato, sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div18 {\n      margin-left: 10px;\n    }\n  }\n\n  .modDiv {\n    color: #000;\n    text-align: start;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    margin-top: 31px;\n    margin-left: 20px;\n    font: 500 24px/22px Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"div": `HomeBuyersCourse_div__7BEjn`,
	"t": `HomeBuyersCourse_t__eNSfw`,
	"sideBar": `HomeBuyersCourse_sideBar__swm0k`,
	"div2": `HomeBuyersCourse_div2__1oItL`,
	"div3": `HomeBuyersCourse_div3__qIFzh`,
	"div4": `HomeBuyersCourse_div4__UPvcJ`,
	"column": `HomeBuyersCourse_column__I6wjV`,
	"div5": `HomeBuyersCourse_div5__l9KwL`,
	"div6": `HomeBuyersCourse_div6__hJBP5`,
	"div7": `HomeBuyersCourse_div7__1eE3k`,
	"div8": `HomeBuyersCourse_div8__Pj7vr`,
	"div9": `HomeBuyersCourse_div9__8ZHbH`,
	"div10": `HomeBuyersCourse_div10__qNWag`,
	"div11": `HomeBuyersCourse_div11__Tkdh4`,
	"div12": `HomeBuyersCourse_div12__NBaYv`,
	"div13": `HomeBuyersCourse_div13__e3C0f`,
	"div14": `HomeBuyersCourse_div14__be9vY`,
	"div15": `HomeBuyersCourse_div15__ekM7e`,
	"column2": `HomeBuyersCourse_column2__ZzGrv`,
	"div16": `HomeBuyersCourse_div16__Hkg8j`,
	"div17": `HomeBuyersCourse_div17__B3a-+`,
	"img": `HomeBuyersCourse_img__d9kt1`,
	"img2": `HomeBuyersCourse_img2__+BA9P`,
	"div18": `HomeBuyersCourse_div18__omvaj`,
	"modDiv": `HomeBuyersCourse_modDiv__0Q76G`
};
export default ___CSS_LOADER_EXPORT___;
